import React from 'react'
import DetailCardWithTable from '../../../dpe-usco/components/Details/DetailCardWithTable'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

export const LocationsWidget = ({ data, status }) => {

  const headerCell = value => {
    return (
      <div key={value} className='cell df aic'>
        <span>{value}</span>
      </div>
    )
  }
  const structure = {
    headers: [
      {
        value: 'Name',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Lat',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Long',
        format(){
          return headerCell(this.value)
        }
      }
    ],
    dataKeys: [
      'storage_name',
      'storage_latitude',
      'storage_longitude'
    ]
  }

  return (
    <DetailCardWithTable dataTestId={'locationsTable'} title={'Locations'} structure={structure} data={data || []} statusComponent={status? <TableStatus status={status}/> : null}/>
  )
}

export default LocationsWidget